import {RemoteGetCongenereEligibility} from 'data/usecases/private/home/remote-get-congenere-eligibility';
import {GetCongenereEligibility} from 'domain/usecases/private/home/get-congenere-eligibility';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {HomeEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetCongenereEligibility = (): GetCongenereEligibility =>
	new RemoteGetCongenereEligibility(
		makeBFFApiUrl(HomeEndPoints.congenereEligibility),
		makeAuthorizeHttpClientDecorator(),
	);
